import { put, takeLatest } from 'redux-saga/effects';

import openModalById from '../../../actions/modal-fn/openModalById';
import closeModalById from '../../../actions/modal-fn/closeModalById';
import requestResourceFailureById from '../../../actions/resource-fn/requestResourceFailureById';
import requestResourceSuccessById from '../../../actions/resource-fn/requestResourceSuccessById';
import resetResourceAttemptsById from '../../../actions/resource-fn/resetResourceAttemptsById';
import { ResourceActionComposedProps } from './ResourceAction';

type Props = ResourceActionComposedProps<any> & {
  modalId: number;
  resourceId: number;
};

function* handleRequestFailure(argsGetter: () => Props) {
  const { modalId } = argsGetter();
  yield put(openModalById(modalId));
}

function* handleRequestSuccess(argsGetter: () => Props) {
  const { modalId } = argsGetter();
  yield put(closeModalById(modalId));
}

function* resetResourceAttempts(argsGetter: () => Props) {
  const { resourceId } = argsGetter();
  yield put(resetResourceAttemptsById(resourceId));
}

export default function* resourceActionSaga(argsGetter: () => Props) {
  const { resourceId, modalId } = argsGetter();

  yield takeLatest(`${requestResourceFailureById.type}/${resourceId}`, handleRequestFailure, argsGetter);
  yield takeLatest(`${requestResourceSuccessById.type}/${resourceId}`, handleRequestSuccess, argsGetter);
  yield takeLatest(`${closeModalById.type}/${modalId}`, resetResourceAttempts, argsGetter);
}
